// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:50:32

export default {
  "id": "scary-banban-escape",
  "slug": "scary-banban-escape",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/30d4395dc90648258f773e9ed5432689-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/30d4395dc90648258f773e9ed5432689/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Scary BanBan Escape",
      "description": "Scary Players of the realistic survival horror game BanBan Escape will need to devise a plan to get out of a terrifying kindergarten inhabited by terrifying creatures. The game's intriguing storyline and tense atmosphere have garnered a lot of attention in the gaming community, and it all started with Euphoric Brothers.\n\nIn Banban Kindergarten, the protagonist is huggy, who plays the role of the searcher. Not only is this school deserted, but it also hides several perils and mysteries.\n\n",
      "instructions": "Instructions :\nMove around the map to try to escape each level before the monsters find you and you can't escape.\n\nControls:\n\nWASD to move around the map\nSpacebar to jump\nMouse to move the camera\nF to interact with items",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "escape",
        "levels",
        "roomescape"
      ]
    },
    "zh-CN": {
      "title": "恐怖BanBan逃亡",
      "description": "《BanBan逃生》这款现实生存恐怖游戏的玩家们需要制定计划逃离一个被恐怖生物占据的恐怖幼儿园。游戏引人入胜的故事情节和紧张的氛围在游戏社区中引起了广泛关注，这一切都始于“Euphoric Brothers”。\n\n在《Banban幼儿园》中，主角是huggy，扮演着搜寻者的角色。这所学校不仅荒废，还隐藏着多个危险和谜团。",
      "instructions": "说明：\n在地图上移动，试图在每个关卡中逃脱，在怪物找到你之前你不能逃脱。\n\n控制方式：\n\nWASD键在地图上移动\n空格键跳跃\n鼠标移动摄像头\nF键与物品互动",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "逃脱",
        "关卡",
        "逃脱房间"
      ]
    },
    "zh-TW": {
      "title": "恐懼班班逃亡",
      "description": "BanBan Escape這款現實主義生存恐怖遊戲的驚悚玩家需要制定計劃，從一個充滿恐懼生物的恐怖幼兒園中逃出。遊戲引人入勝的劇情和緊張的氣氛在遊戲社群中受到大量關注，一切都從Euphoric Brothers開始。\n\n在Banban幼兒園中，主角是huggy，他扮演尋找者的角色。這所學校不僅荒蕪，還隱藏著多個危險和謎團。",
      "instructions": "說明：\n在怪物找到你之前，在地圖上移動以嘗試逃離每一關。\n\n控制方式：\n\nWASD 鍵移動地圖\n空格鍵跳躍\n滑鼠移動相機\nF 鍵與物品互動",
      "genres": [
        "冒險",
        "敏捷"
      ],
      "tags": [
        "逃離",
        "關卡",
        "密室逃脫"
      ]
    },
    "zh-HK": {
      "title": "驚悚BanBan逃亡",
      "description": "恐怖玩家在真實生存驚悚遊戲《BanBan Escape》中需要制定計劃逃離一個充滿恐怖生物的恐怖幼兒園。遊戲引人入勝的故事情節和緊張的氣氛在遊戲社群中引起了很多關注，一切皆源於「Euphoric Brothers」。\n\n在《Banban 幼兒園》中，主角是「huggy」，扮演搜尋者的角色。這所學校不僅荒蕪，還隱藏著多個危險和謎團。",
      "instructions": "指示：\n在怪物找到你之前，在地圖上移動以嘗試逃離每一關。\n\n控制：\n\nWASD 鍵移動地圖\n空格鍵跳躍\n滑鼠移動相機\nF 鍵與物品互動",
      "genres": [
        "冒險",
        "靈巧"
      ],
      "tags": [
        "逃離",
        "關卡",
        "密室逃離"
      ]
    },
    "ja": {
      "title": "スカイリー・バンバン・イージー・エスケイプ",
      "description": "リアリスティックなサバイバルホラー游戏「BanBan Escape」の恐ろしいプレイヤーは、恐ろしい生物が住む恐ろしい幼稚園から脱出するための計画を策定する必要があります。このゲームの興味深いストーリーと緊迫した雰囲気は、ゲームコミュニティに多くの注目を集め、すべてはEuphoric Brothersから始まりました。\n\n「Banban幼稚園」では、主人公は抱きしめることができる「探検者」の役割を演じます。この学校は荒廃しており、いくつかの危険や謎を隠しています。",
      "instructions": "操作説明：\n地図を動かして、モンスターに見つからないように各レベルから逃げることを試みてください。\n\nコントロール：\n\nWASDで地図を動かす\nスペースバーでジャンプ\nマウスでカメラを動かす\nFでアイテムと対話する",
      "genres": [
        "アドベンチャー",
        "アギリティー"
      ],
      "tags": [
        "脱出",
        "レベル",
        "ルームエスケープ"
      ]
    },
    "ko": {
      "title": "스캔들리한 밤밤 탈출",
      "description": "BanBan Escape이라는 현실적 생존 공포 게임의 공포적인 플레이어들은 무서운 생물로 인해 공포된 어린이집에서 탈출 계획을 세워야 합니다. 이 게임의 흥미로운 스토리라인과 긴장감 넘치는 분위기는 게이밍 커뮤니티에서 많은 주목을 받았으며, 모든 것은 Euphoric Brothers로부터 시작되었습니다.\n\nBanban 어린이집에서는 주인공인 휰리가 탐정 역할을 합니다. 이 학교는 방치되어 있을 뿐만 아니라 여러 가지 위험과 미스터리를 숨겨 있습니다.",
      "instructions": "지시:\n지도를 돌아다니며 몬스터가 찾지 못하게 모든 레벨을 탈출해야 합니다.\n\n컨트롤:\nWASD로 지도를 이동\n스페이스바로 점프\n마우스로 카메라 이동\nF로 아이템과 상호작용",
      "genres": [
        "모험",
        "신속도"
      ],
      "tags": [
        "탈출",
        "레벨",
        "방탈출"
      ]
    },
    "fr": {
      "title": "Échappée effrayante BanBan",
      "description": "Les joueurs effrayés du jeu de survival horror réaliste BanBan Escape devront élaborer un plan pour s'échapper d'une école maternelle terrifiante habitée par des créatures effrayantes. Le scénario intrigant et l'atmosphère tendue du jeu ont attiré beaucoup d'attention dans la communauté des joueurs, et tout a commencé avec les Euphoric Brothers.\n\nDans la Maternelle Banban, le protagoniste est Huggy, qui joue le rôle du chercheur. Non seulement cette école est déserte, mais elle cache également plusieurs dangers et mystères.",
      "instructions": "Instructions :\nNaviguez sur la carte pour essayer de fuir chaque niveau avant que les monstres ne vous trouvent et que vous ne puissiez plus vous échapper.\n\nContrôles :\n\nWASD pour vous déplacer sur la carte\nBarre d'espace pour sauter\nSouris pour déplacer la caméra\nF pour interagir avec les objets",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "Échapper",
        "niveaux",
        "évasion de pièce"
      ]
    }
  }
};
